import { lazy } from 'react';

export const CreateOffer = lazy(() => import('./CreateOffer.component'));
